enum ProductSettingsRoutes {
  List = '/product-settings',
}

export default ProductSettingsRoutes
